<template>
  <div class="center-warp">
    <div class="inner">
      <div class="swiper-container banner">
        <div class="swiper-wrapper">

          <div class="swiper-slide" v-for="item in banners">
            <img :src="item.pic_url" alt="" @click="handleClickBanner(item.target_url)">
          </div>

        </div>
        <div class="banner-pagination swiper-pagination" slot="pagination"></div>
      </div>
      <div class="h-title">欢迎使用OrtoNow!</div>
      <div class="d-flex-between">
        <div class="order-card">
          <div class="d-flex-between">
            <div class="order-card-name">
              <i class="iconfont icon-daiquerendingdan"></i>
              <div class="word-16">订单中心</div>
            </div>
            <div class="word-16">{{ orderTotal }}</div>
          </div>
          <div class="order-card-cont" v-if="order.length">
            <div class="order-list" v-for="item in order" :key="item.id" @click="$router.push({ path:'bill_center/detail', query:{id:item.id} })">
              <div class="order-list-info">{{ item.patient_name ? `(${item.patient_name})` : '' }} {{ item.product_name }}</div>
              <div class="order-list-status">{{ item.order_status_text }}</div>
            </div>
          </div>
          <template v-else>
            <Empty :info="'暂无待确认订单'"></Empty>
          </template>
        </div>
        <div class="order-card">
          <div class="d-flex-between">
            <div class="order-card-name">
              <i class="iconfont icon-jijiangkaishidehuizhen"></i>
              <div class="word-16">即将开始的会诊</div>
            </div>
            <div class="word-16">{{ meetingTotal }}</div>
          </div>
          <div class="order-card-cont" v-if="meeting.length">
              <div class="order-list" v-for="item in meeting" :key="item.id" @click="goPage(item,'meeting')">
                <div class="order-list-info">({{ item.patient.name }}) {{ item.format_start_time }}开始</div>
                <div class="order-list-status"></div>
              </div>
          </div>
          <template v-else>
            <Empty :info="'暂无即将开始的会诊'"></Empty>
          </template>
        </div>
        <div class="order-card">
          <div class="d-flex-between">
            <div class="order-card-name">
              <i class="iconfont icon-shoulizhongdebingli"></i>
              <div class="word-16">咨询的病例</div>
            </div>
            <div class="word-16">{{ patientTotal }}</div>
          </div>
          <div class="order-card-cont" v-if="patient.length">
              <div class="order-list" v-for="item in patient" :key="item.id" @click="$router.push({ path:'case_management', query:{id:item.id} })">
                <div class="order-list-info">您正在向导师咨询病例 ({{ item.name }})</div>
                <div class="order-list-status"></div>
              </div>
          </div>
          <template v-else>
            <Empty :info="'暂无咨询的病例'"></Empty>
          </template>
        </div>
      </div>
      <div class="h-title">最新消息</div>
      <div class="news-card">
        <template v-if="message.length">
          <div class="order-list" v-for="item in message" :key="item.id" @click="handleSysMessageClick(item)">
            <div class="order-list-info" style="padding-right: 10px">
              <span class="dot-position" :class="{'bg-red': item.is_look === 0}"></span>
              <span class="title">{{ item.title }}</span>
              <span>{{ item.content }}</span>
            </div>
            <div class="order-list-status">{{ item.format_send_time }}</div>
          </div>
        </template>
        <template v-else>
          <Empty :info="'暂无最新消息'" :img-width="'200px'"></Empty>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/js/swiper'
import 'swiper/css/swiper.min.css'
import {getDoctorData} from "@/http/home";
import {getBanner} from "@/http/banner";
import toPageBySysMessage from "@/mixin/toPageBySysMessage";

export default {
  name: "DoctorHome",
  mixins: [toPageBySysMessage],
  data() {
    return {
      banners: [],
      order: [],
      orderTotal: 0,
      meeting: [],
      meetingTotal: 0,
      patient: [],
      patientTotal: 0,
      message: [],
    };
  },
  created() {
    this.getBanner();
    this.getHomeData();
  },
  mounted() {

  },
  methods: {
    getBanner() {
      getBanner({
        banner_id: 4
      }).then(res => {
        this.banners = res.data;
        this.$nextTick(() => {
          this.initBanner()
        })
      });
    },
    getHomeData() {
      getDoctorData().then(res => {
        this.order = res.data.order.data;
        this.orderTotal = res.data.order.total;
        this.meeting = res.data.meeting.data;
        this.meetingTotal = res.data.meeting.total;
        this.patient = res.data.patient.data;
        this.patientTotal = res.data.patient.total;
        this.message = res.data.message;
      })
    },
    initBanner() {
      new Swiper('.banner', {
        autoplay: true,
        loop: true,
        pagination: {
          el: '.banner-pagination',
          clickable: true
        }
      })
    },
    handleClickBanner(url) {
      if (!url) return;
      window.open(url);
    },
    handleSysMessageClick(row) {
      this.toPageBySysMessage(row);
    },
    goPage(item,type){
      if(type == 'meeting'){
        this.$router.push({path:`/consultation_detail?meeting_id=${item.id}&case_id=${item.patient.id}`})
      }
    }
  }
}
</script>

<style scoped src="../../assets/css/home.css"></style>
